import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Notification, networkNotification } from '../../entities/entities';
import { LoggingService, NotifyService } from '../../services/services';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
})
export class SettingsComponent implements OnInit, OnDestroy {
  isWorking: boolean;
  isError: boolean;
  private sub: any;

  constructor(
    private loggingService: LoggingService,
    private notifyService: NotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {

    if (loggingService) {
      loggingService.logPageView('Settings');
    }
  }

  ngOnInit() {
  }
 

  ngOnDestroy() {

    if (this.sub) {
      this.sub.unsubscribe();
    }

  }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/settings/settings.component.ts